import { SkyWaitPageAdapterService } from './wait-page-adapter.service';

export { SkyWaitComponent } from './wait.component';
export { SkyWaitService } from './wait.service';
export { SkyWaitModule } from './wait.module';

export const SKY_WAIT_PROVIDERS: any[] = [
  SkyWaitPageAdapterService
];
